<template>
    <div class="portfolioStockLotWidget">
        <div v-if="sortedStockLots.length > 0" class="psSummary">
            <div class="psTotal">
                <div class="lab">{{ $tc('dictio.action', remainingStockShareCount) }}</div>
                <div class="val">{{ remainingStockShareCount}}</div>
            </div>
            <div class="psRealProfit">
                <div class="lab">{{ $t('UserStockWatchingList.portfolio.projectedGain') }}</div>
                <div class="val">{{ projectedGain }}</div>
            </div>
            <div class="psAllProfit">
                <div class="lab">{{ $t('UserStockWatchingList.portfolio.profitIncludingUnrealized') }}</div>
                <div class="val">{{ profitIncludingUnrealized }}</div>
            </div>
        </div>
        <div class="newLot">
            <PortfolioEditStockLotDialog ref="editStockLotDialog" :stock="stock" @saveLot="saveLotAsked" :mobile="true" @delete="deleteLotAsked" @move="moveLotAsked"></PortfolioEditStockLotDialog>
        </div>
        <div v-if="sortedStockLots.length > 0" class="psLots">
            <div class="psLot" v-for="(lot, i) in sortedStockLots" :key="i">
                <PortfolioStockLotMobile :lastPrice="stock.stockDateTimeSnapshot.price" :lot="lot" @editLot="editLot"></PortfolioStockLotMobile>
            </div>
        </div>
        <ConfirmDialog ref="confirmDelete" @answered="deleteLotAnswered"></ConfirmDialog>
    </div>
</template>

<script>
import ConfirmDialog from '../controls/ConfirmDialog.vue';
import PortfolioEditStockLotDialog from './PortfolioEditStockLotDialog.vue';
import PortfolioStockLotMobile from './PortfolioStockLotMobile.vue';
import PortfolioStockLotWidgetMixin from './PortfolioStockLotWidgetMixin';

export default {
    props: ['portfolioId', 'stockId', 'stockinfo'],
    mixins: [PortfolioStockLotWidgetMixin],
    components: { PortfolioStockLotMobile, PortfolioEditStockLotDialog, ConfirmDialog },
    computed: {
        stock() {
            const storedStock = this.stockId ? this.$store.getters.portfolioStock({ portfolioId: this.portfolioId, stockId: this.stockId }) : null
            return storedStock || this.stockinfo
        },
        stockStatistics() {
            return this.stock ? this.stock.statistics : null;
        },
        sortedStockLots() {
            const lots = this.stock ? JSON.parse(JSON.stringify(this.stock.lots)) : [];
            return lots.sort((a, b) => {
                return a.dateOfTransaction < b.dateOfTransaction ? 1 : -1;
            });
        },
        remainingStockShareCount() {
            return this.stockStatistics ? this.stockStatistics.remainingStockShareCount : 0
        },
        projectedGain() {
            return this.stockStatistics.totalProfitIncludingUnrealized ? this.stockHtmlHelper.formatPriceWithDigit(this.stockStatistics.totalProfitIncludingUnrealized, 2) : '';
        },
        profitIncludingUnrealized() {
            return this.stockStatistics.percentageOfProfitIncludingUnrealized ? this.stockHtmlHelper.formatPriceWithDigit(this.stockStatistics.percentageOfProfitIncludingUnrealized, 2) + '%' : '';
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/breakpoints.scss";
.portfolioStockLotWidget {
    display: flex;
    flex-direction: column;
    z-index: 1;
    .psLots {
        background-color: #FFF;
        padding: 5px;
        .psLot {
            padding: 5px 0;
            &:not(:last-child) {
                border-bottom: solid 1px #EEE;
            }
        }
    }
    .psSummary {
        // font-size: 0.7rem;
        padding: 6px;
        border-bottom: solid 1px var(--agora);
        background-color: var(--agoraBG);
        display: flex;
        >*{
            flex: 2;
            display: flex;
            flex-direction: column;
        }
        .psTotal {
            flex: 1;
        }
        .psRealProfit {
            text-align: end;
        }
        .psAllProfit {
            text-align: end;
        }
        .lab {
            text-transform: capitalize;
        }
        .val {
            font-weight: bold;
        }
        @media screen and (max-width: $tablet) {
            font-size: 0.875rem;
        }
    }
    .newLot {
        padding: 10px;
    }
}
</style>